module.exports = __webpack_public_path__ + "static/img/Y2D20.20715cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Y2D20.png
// module id = CvHy
// module chunks = 2